module.exports = "https://static.wanderu.com/static/media/us.3cc0d38b.svg";